import React from "react";
import classnames from "classnames";
import styles from "./Transcript.module.scss";

interface Props {
  value?: string;
}

const POSITIVE = "positive";

function UserFeedback({ value }: Props) {
  if (!value) {
    return null;
  }
  const isPositive = value === POSITIVE;

  return (
    <span className={classnames(styles.badge, isPositive ? styles.positiveBadge : styles.negativeBadge)}>
      {isPositive ? "👍 Thumbs Up" : "👎 Thumbs Down"}
    </span>
  );
}

export default UserFeedback;
